// lib/wanduhrzeit.js
//
// Zeitpunkte aus DATETIME-Spalten (z. B. kaempfe.geplante_zeit) richtig lesen.
//
// ⚠️ Die Datenbank speichert ORTSZEIT (10:30 heißt 10:30 in der Halle). Die
// Anbindung (backend/db.js, timezone '+00:00') liest sie aber als UTC und
// schickt „…T10:30:00.000Z". new Date() macht daraus 12:30 — zwei Stunden
// zu spät auf Hallenschirm, Bracket und Zuschaueransicht (gefunden 27.09.2026).
//
// Die Anbindung global umzustellen wäre gefährlich: dann rutschten alle reinen
// Datumsfelder („2027-03-13") im Browser auf den Vortag. Deshalb hier: das
// „Z" weglassen und die Zeit als das lesen, was sie ist — Wanduhrzeit.

/** DATETIME-Wert aus der API als lokale Zeit; null bei leer/ungültig. */
export function wanduhrzeit(wert) {
  if (!wert) return null;
  const s = String(wert).replace(/\.\d+Z$|Z$/, '').replace(' ', 'T');
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}
